import { AccessibleText } from '@/components/AccessibleText'

interface DisclaimerProps {
  id: string
  text: string
  accessibleText: string
  className?: string
  light?: 'high' | 'solid'
}

export const Disclaimer = ({ id, text, accessibleText, className, light }: DisclaimerProps) => (
  <AccessibleText
    id={id}
    tag="p"
    text={text}
    accessibleText={accessibleText}
    className={className}
    light={light}
  />
)
